"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LogChangedValue = void 0;
var _react = require("react");
var _Stack = _interopRequireDefault(require("../Stack"));
var _Icon = require("../Icon");
var _LogChip = _interopRequireDefault(require("./LogChip"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["type", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      marginLeft: 5,
      marginRight: -6
    }
  };
}, {
  name: 'GgLogTypeIcon'
});
var TypeIcon = function TypeIcon(_ref) {
  var type = _ref.type,
    _omittedChipIconClassName = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  switch (type) {
    case 'remove':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.RemoveIcon, {
        sx: {
          fontSize: 16
        },
        color: 'error',
        className: classes.root
      });
    case 'add':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.AddIcon, {
        sx: {
          fontSize: 16
        },
        color: 'success',
        className: classes.root
      });
    case 'change':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.SyncIcon, {
        sx: {
          fontSize: 16
        },
        color: 'primary',
        className: classes.root
      });
    default:
      return null;
  }
};
var LogChangedValue = exports.LogChangedValue = function LogChangedValue(_ref2) {
  var value = _ref2.value,
    newValue = _ref2.newValue;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    direction: 'row',
    spacing: 0.5,
    alignItems: 'center',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: value
    }), newValue !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "\u2794"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: newValue
      })]
    }) : null]
  });
};
var LogChanges = function LogChanges(_ref3) {
  var type = _ref3.type,
    label = _ref3.label,
    children = _ref3.children,
    _ref3$inChip = _ref3.inChip,
    inChip = _ref3$inChip === void 0 ? true : _ref3$inChip;
  var validChildren = _react.Children.toArray(children).filter(_react.isValidElement);
  var count = validChildren.length;
  if (inChip) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogChip["default"], {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(TypeIcon, {
        type: type
      }),
      label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
        direction: 'row',
        spacing: 0.5,
        alignItems: 'center',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
          flex: '1 0 auto',
          children: [label, ":"]
        }), validChildren.map(function (child, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
            children: [child, " ", i < count - 1 ? ', ' : null]
          }, i);
        })]
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    direction: 'row',
    spacing: 0.5,
    alignItems: 'center',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TypeIcon, {
      type: type
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      flex: '1 0 auto',
      children: [label, ":"]
    }), validChildren.map(function (child, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [child, " ", i < count - 1 ? ', ' : null]
      }, i);
    })]
  });
};
var _default = exports["default"] = LogChanges;